'use client'
import * as React from 'react'
import { BlogGridProps } from './types'
import BlogCard from '../BlogCard'

const BlogGrid = ({ blogs }: BlogGridProps) => {
    return (
        <div className="relative -top-[50px] lg:-top-[200px] z-[100] container">
            <div className="w-full gap-16 lg:gap-20 flex flex-col">
                <div className="lg:gap-5 gap-4 flex flex-wrap">
                    {blogs.map(blog => (
                        <BlogCard {...blog} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BlogGrid
